import { v2Request } from "../helpers/request";

export const addAlternateEmails = (payload: JObj) => {
  return v2Request("/company-emails", {
    body: JSON.stringify(payload),
    method: "POST",
  });
};
export const getAlternateEmails = () => {
  return v2Request(`/company-emails`);
};
export const deleteAlternateEmail = (id: number) => {
  return v2Request(`/company-emails/${id}`, {
    method: "DELETE",
  });
};
